import {useState, useEffect} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {toast} from "react-toastify";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import ExportButton from "../components/ExcelButton";
import {getAllStorage} from "../services/shipment.service";
import {
	editBlockOfStorage,
	getBlocksOfStorage,
} from "../services/block.service";

const StorageBalancePage = () => {
	const [filters, setFilters] = useState({
		block: 0,
		order: "",
		client: "",
		clients: "all",
		bundle: "all",
		category: "all",
		furniture: "all",
	});
	const [searchText, setSearchText] = useState("");
	const [uniques, setUniques] = useState([]);
	const [showDialog, setShowDialog] = useState(false);
	const [selectedBlock, setSelectedBlock] = useState(null);
	const [selectedUnique, setSelectedUnique] = useState(null);
	const [blocks, setBlocks] = useState([]);
	const [loading, setLoading] = useState(false);

	let filteredUniques = uniques.filter(
		(item) => !filters.block || item.unique.block?.id === filters.block
	);

	if (filters.client) {
		filteredUniques = uniques.filter((item) =>
			item?.demand_furniture?.demand?.customer?.name
				.toLowerCase()
				.includes(filters.client.toLowerCase())
		);
	}

	const uniqueFurnitureNames = [
		...new Set(uniques.map((value) => value.furniture.name)),
	];

	const furnitureOptions = [
		{label: "Барчаси", value: "all"},
		...uniqueFurnitureNames.map((name) => ({
			label: name,
			value: name,
		})),
	];

	if (filters.furniture !== "all") {
		filteredUniques = uniques.filter(
			(item) => item.furniture.name === filters.furniture
		);
	}

	const uniqueFurnitureComplekt = [
		...new Set(
			uniques.map(
				(value) => value.furniture.komplekt_furniture[0].komplekt.name
			)
		),
	];

	const bundleOptions = [
		{label: "Барчаси", value: "all"},
		...uniqueFurnitureComplekt.map((name) => ({
			label: name,
			value: name,
		})),
	];

	if (filters.bundle !== "all") {
		filteredUniques = uniques.filter(
			(item) =>
				item.furniture.komplekt_furniture[0].komplekt.name === filters.bundle
		);
	}

	if (searchText) {
		filteredUniques = uniques.filter((item) => {
			const block = item?.unique?.block?.name || "";
			const order = item?.unique?.name || "";
			const client = item?.demand_furniture?.demand?.customer?.name || "";
			const furniture = item?.furniture?.name || "";
			const bundle =
				item?.furniture?.komplekt_furniture?.[0]?.komplekt?.name || "";
			const category = item?.furniture?.category_furniture?.name || "";

			const searchLower = searchText.toLowerCase();

			return (
				block.toLowerCase().includes(searchLower) ||
				order.toLowerCase().includes(searchLower) ||
				client.toLowerCase().includes(searchLower) ||
				furniture.toLowerCase().includes(searchLower) ||
				bundle.toLowerCase().includes(searchLower) ||
				category.toLowerCase().includes(searchLower)
			);
		});
	}

	const fetchRecievedInvoices = async () => {
		setLoading(true);
		try {
			const {uniques} = await getAllStorage();
			setUniques(uniques);
		} catch (error) {
			console.log(error);
			toast.error("Складни корсатишда хатолик");
		} finally {
			setLoading(false);
		}
	};

	const handleBlockChange = (e) => {
		setShowDialog(true);
		setSelectedBlock(e.rowData?.unique?.block?.id || null);
		setSelectedUnique(e.rowData.unique_id);
	};

	const handleStorageEdit = async () => {
		setLoading(true);
		try {
			await editBlockOfStorage(selectedBlock, selectedUnique);

			await fetchRecievedInvoices();
			toast.success("Склад озгартирилди");
			setShowDialog(false);
		} catch (error) {
			toast.error("Склад озгартиришда хатолик");
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const fetchBlocks = async () => {
			try {
				const response = await getBlocksOfStorage();
				setBlocks(response.blocks);
			} catch (error) {
				console.log(error);
				toast.error("Склад ни корсатишда хатолик");
			}
		};

		fetchRecievedInvoices();
		fetchBlocks();
	}, []);

	const columns = [
		{label: "N", key: "index"},
		{label: "Блок", key: "unique.block.name"},
		{label: "Заказ", key: "unique.name"},
		{
			label: "Клиент",
			field: (row) =>
				row.demand_furniture_id
					? row.demand_furniture.demand.customer.name
					: "Супермаркет",
		},
		{
			label: "Комплект",
			field: (row) =>
				`${row.furniture.category_furniture.name} ${row.furniture.komplekt_furniture[0].komplekt.name}`,
		},
		{label: "Мебель", key: "furniture.name"},
		{label: "Сони", key: "amount"},
	];

	return (
		<MainLayout header="Склад баланси">
			<div>
				<div className="flex items-center w-full gap-4 mb-4">
					<div className="relative flex items-center w-full">
						<i className="absolute text-gray-400 -translate-y-1/2 pointer-events-none pi pi-search left-3 top-1/2" />
						<InputText
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							placeholder="Барча майдонлар бўйича қидиринг..."
							className="px-4 py-2 text-base border w-[20em] !w-full pl-9 pt-3"
						/>
					</div>
					<ExportButton
						data={filteredUniques}
						columns={columns}
						fileName="Склад_остаток"
					/>
				</div>
				<DataTable
					className="custom-row-border"
					value={filteredUniques}
					rows={10}
					rowsPerPageOptions={[10, 25, 50, 100]}
					cellSelection
					selectionMode="single"
					onCellSelect={(e) => handleBlockChange(e)}
					loading={loading}
					filterDisplay="row">
					<Column
						field=""
						header="N"
						headerClassName="w-fit"
						body={(_, {rowIndex}) => rowIndex + 1}
					/>
					<Column
						className="min-w-[300px]"
						field="unique.block.name"
						header="Блок"
						filter
						filterPlaceholder="block nomi..."
						filterElement={() => (
							<Dropdown
								value={filters.block}
								options={blocks.map((block) => ({
									label: block.name,
									value: block.id,
								}))}
								onChange={(e) => setFilters({...filters, block: e.value})}
								className="border"
								placeholder="Хамма блоклар"
								showClear={filters.block}
							/>
						)}
					/>
					<Column
						className="min-w-[300px]"
						field="unique.name"
						header="Заказ"
						filter
						filterElement={() => (
							<InputText
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
								placeholder="Заказни кидиринг..."
								className="px-3 h-[40px] text-base font-light placeholder:text-gray-600 border border-gray-300 rounded-md placeholder:font-normal placeholder:text-gray-500 focus:outline-none"
							/>
						)}
					/>
					<Column
						className="min-w-[300px]"
						field=""
						header="Клиент"
						body={(rowData) =>
							rowData.demand_furniture_id
								? rowData.demand_furniture.demand.customer.name
								: "Супермаркет"
						}
						filter
						filterElement={() => (
							<InputText
								className="px-3 h-[40px] text-base font-light placeholder:text-gray-600 border border-gray-300 rounded-md placeholder:font-normal placeholder:text-gray-500 focus:outline-none"
								placeholder="Мижосларни кидиринг..."
								onChange={(e) =>
									setFilters({...filters, client: e.target.value})
								}
							/>
						)}
					/>
					<Column
						className="min-w-[300px]"
						field=""
						header="Комплект"
						body={(rowData) =>
							`${rowData.furniture.category_furniture.name} ${rowData.furniture.komplekt_furniture[0].komplekt.name}`
						}
						filter
						filterElement={() => (
							<Dropdown
								value={filters.bundle}
								options={bundleOptions}
								onChange={(e) => setFilters({...filters, bundle: e.value})}
								className="border"
								// disabled
							/>
						)}
					/>
					<Column
						className="min-w-[300px]"
						field="furniture.name"
						header="Мебель"
						filter
						filterElement={() => (
							<Dropdown
								value={filters.furniture}
								options={furnitureOptions}
								onChange={(e) => setFilters({...filters, furniture: e.value})}
								className="border"
								// disabled
							/>
						)}
					/>
					<Column field="amount" header="Сони" />
				</DataTable>
			</div>
			{showDialog && (
				<Dialog
					visible={showDialog}
					onHide={() => setShowDialog(false)}
					header="Блокни озгартириш"
					footer={
						<div className="flex justify-between mt-2 min-w-[400px]">
							<Button
								label="Бекор килиш"
								icon="pi pi-times"
								onClick={() => setShowDialog(false)}
								className="p-button-text"
								loading={loading}
							/>
							<Button
								label="Озгартириш"
								icon="pi pi-check"
								className="p-button-danger"
								onClick={handleStorageEdit}
								loading={loading}
							/>
						</div>
					}>
					<div className="flex flex-col w-[400px]">
						<label className="mb-1 text-lg">Блок</label>
						<Dropdown
							value={selectedBlock}
							options={blocks.map((block) => ({
								label: block.name,
								value: block.id,
							}))}
							onChange={(e) => setSelectedBlock(e.value)}
							className="w-full border rounded-lg"
							disabled={loading}
						/>
					</div>
				</Dialog>
			)}
		</MainLayout>
	);
};

export default StorageBalancePage;
